export default __webpack_public_path__ + "static/media/phylactere_studeren.064e38e2.png";